/* unplugin-vue-components disabled */import { render } from "./list.vue?vue&type=template&id=81931870&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=81931870&scoped=true&lang=scss"
import "./list.vue?vue&type=style&index=1&id=81931870&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81931870"]])

export default __exports__